(ns rems.common.atoms)

(def nbsp "\u00A0") ; non breaking space
(def nbhy "\u2011") ; non breaking hyphen
(def hamburger "\u2630") ; the hamburger menu icon
